import { Routes } from '@angular/router';
import { AppLayoutComponent } from './layout/app.layout.component';
import { ErrorComponent } from '@auth/error/error.component';
import {
    loggedIn,
    AuthGuard,
    redirectUnauthorizedTo,
    canActivate,
} from '@angular/fire/auth-guard';
import { AuthBaseComponent } from './auth-base/auth-base.component';
import { PrincipalComponent } from '@pages/principal/principal.component';
import { Faq } from '@pages/principal/faq/faq';
import { PrivacyPolicyComponent } from '@pages/privacy-policy/privacy-policy.component';
import { TermsAndConditionsPageComponent } from '@pages/terms-and-conditions/terms-and-conditions.component';
import { DataDeletionComponent } from '@pages/data-deletion/data-deletion.component';
import { FormConsorcistaComponent } from '@pages/form-consorcista/form-consorcista.component';
import { KeyRequestFormComponent } from '@pages/key-request-form/key-request-form.component';
const redirectUnauthorizedToLogin = () =>
    redirectUnauthorizedTo(['auth/login']);

export const routes: Routes = [
    {
        path: '',
        component: PrincipalComponent,
    },
    {
        path: 'privacy-policy',
        component: PrivacyPolicyComponent,
    },
    {
        path: 'terms-and-conditions',
        component: TermsAndConditionsPageComponent,
    },
    {
        path: 'data-deletion',
        component: DataDeletionComponent,
    },
    {
        path: 'preguntas',
        component: Faq,
    },
    {
        path: 'nuevo-consorcista',
        component: FormConsorcistaComponent,
    },
    {
        // formulario público de pedido de copia de llave (AF298), con el link que manda el agente
        path: 'pedido-llave',
        component: KeyRequestFormComponent,
    },
    {
        path: '',
        component: AppLayoutComponent,
        children: [
            {
                path: '',
                canActivate: [AuthGuard],
                data: { authGuardPipe: redirectUnauthorizedToLogin },
                loadChildren: () =>
                    import('./pages/pages.routes').then((m) => m.routes),
            },
        ],
    },
    {
        path: 'test',
        loadChildren: () => import('./test/test.routes').then((m) => m.routes),
    },
    {
        path: 'auth',
        component: AuthBaseComponent,
        loadChildren: () => import('./auth/auth.routes').then((m) => m.routes),
    },
    { path: 'notfound', component: ErrorComponent },
    { path: '**', redirectTo: '/notfound' },
];
